import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import './footer.css'

const Footer = (props) => {
  const { t } = useTranslation('common')

  const scrollToCalculatorIfVisible = () => {
    window.setTimeout(() => {
      const calculatorSection = document.getElementById('calculatorSection')
      if (!calculatorSection) return

      const header = document.querySelector('.navigation')
      const headerHeight = header ? header.offsetHeight : 80
      const rect = calculatorSection.getBoundingClientRect()
      const absoluteTop = rect.top + window.pageYOffset
      const visibleHeight = window.innerHeight - headerHeight
      const scrollPosition = absoluteTop - headerHeight - (visibleHeight / 2) + (rect.height / 2) + 110

      window.scrollTo({
        top: Math.max(0, scrollPosition),
        behavior: 'smooth'
      })
    }, 0)
  }

  return (
    <div className="footer-container">
      <footer className="footer">
        <div className="footer-main">
          <div className="footer-container">
            <div className="footer-brand">
              <div className="footer-logo">
                <span className="footer-brand-mark" aria-hidden="true">
                  <img src="/favicon.jpeg" alt="" />
                </span>
                <div className="footer-logo-copy">
                  <div className="footer-logo-row">
                    <h2 className="footer-brand-name">ORRAM</h2>
                    <span className="footer-brand-tagline">Frames</span>
                  </div>
                  <span className="footer-logo-byline">by Sasha de saint Tropez</span>
                </div>
              </div>
              <p className="footer-brand-description">
                {t('footer.tagline')}
              </p>
              <div className="footer-social">
                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <div aria-label="Instagram" className="footer-social-link">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <rect
                          x="2"
                          y="2"
                          rx="5"
                          ry="5"
                          width="20"
                          height="20"
                        ></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <div aria-label="Facebook" className="footer-social-link">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-link">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-navigation">
              <div className="footer-nav-column">
                <h3 className="footer-nav-title">{t('footer.services.title')}</h3>
                <nav className="footer-nav-list">
                  <Link to="/#calculatorSection" onClick={scrollToCalculatorIfVisible}>
                    <div className="footer-nav-link">
                      <span>{t('footer.services.frameCalculator')}</span>
                    </div>
                  </Link>
                  <div className="footer-nav-link footer-nav-link--disabled">
                      <span>{t('footer.services.installation')}</span>
                  </div>
                </nav>
              </div>
              <div className="footer-nav-column">
                <h3 className="footer-nav-title">{t('footer.support.title')}</h3>
                <nav className="footer-nav-list">
                  <div className="footer-nav-link footer-nav-link--disabled">
                      <span>{t('footer.support.careGuide')}</span>
                  </div>
                  <div className="footer-nav-link footer-nav-link--disabled">
                      <span>{t('footer.support.warranty')}</span>
                  </div>
                  <Link to="/cgv">
                    <div className="footer-nav-link">
                      <span>{t('footer.support.returns')}</span>
                    </div>
                  </Link>
                  <div className="footer-nav-link footer-nav-link--disabled">
                      <span>{t('footer.support.faq')}</span>
                  </div>
                </nav>
              </div>
              <div className="footer-nav-column">
                <h3 className="footer-nav-title">{t('footer.getInTouch.title')}</h3>
                <div className="footer-contact-info">
                  <div className="footer-contact-item">
                    <div className="footer-contact-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                          <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                        </g>
                      </svg>
                    </div>
                    <a href="mailto:orders@orram.shop">
                      <div className="footer-contact-link">
                        <span>orders@orram.shop</span>
                      </div>
                    </a>
                  </div>
                  <div className="footer-contact-item">
                    <div className="footer-contact-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    </div>
                    <a href="tel:+33617596447">
                      <div className="footer-contact-link">
                        <span>+33 6 17 59 64 47</span>
                      </div>
                    </a>
                  </div>
                  <div className="footer-contact-item">
                    <div className="footer-contact-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                          <circle r="3" cx="12" cy="10"></circle>
                        </g>
                      </svg>
                    </div>
                    <a href="https://www.google.com/maps/search/?api=1&query=10%20place%20de%20l%27Ormeau%2083990%20Saint-Tropez%20France" target="_blank" rel="noopener noreferrer">
                      <div className="footer-contact-link">
                        <span>Saint-Tropez, France</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-newsletter">
              <h4 className="footer-newsletter-title">{t('footer.newsletter.title')}</h4>
              <p className="footer-newsletter-description">
                {t('footer.newsletter.placeholder')}
              </p>
              <form className="footer-newsletter-form">
                <input
                  type="email"
                  required="true"
                  placeholder={t('footer.newsletter.emailPlaceholder')}
                  className="footer-newsletter-input"
                />
                <button type="submit" className="btn btn-accent">
                  {t('footer.newsletter.subscribe')}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-container">
            <div className="footer-bottom-content">
              <p className="footer-copyright">
                {t('footer.copyright')}
              </p>
              <div className="footer-legal">
                <Link to="/mentions-legales" className="footer-legal-link">
                  <span>Mentions légales</span>
                </Link>
                <Link to="/cgv" className="footer-legal-link">
                  <span>CGV</span>
                </Link>
                <Link to="/privacy-policy" className="footer-legal-link">
                  <span>{t('footer.legal.privacy')}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
